import AutomationsGallery from '@/components/views/AutomationsView/AutomationsGallery';
import { AutomationsIcon } from '@/components/icons/AutomationsIcon';
import { Box, useTheme } from '@mui/material';
import React from 'react';
import { PageHeader } from '@/components/layouts/PageHeader';

export const AutomationsView = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				pt: 1,
				pb: 3,
			}}
		>
			<PageHeader
				title='Automations'
				icon={
					<AutomationsIcon
						{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
					/>
				}
			/>
			<Box px={3}>
				<AutomationsGallery />
			</Box>
		</Box>
	);
};
